import { render, staticRenderFns } from "./PersonalInformationSection.vue?vue&type=template&id=07c08dcb"
import script from "./PersonalInformationSection.vue?vue&type=script&lang=js"
export * from "./PersonalInformationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports